import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

export const LayoutSkinny = Styled.article`
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  ${media.medium`
    width: auto;
    max-width: 42.5em;
  `}
`;

LayoutSkinny.displayName = 'LayoutSkinny';

export const LayoutSkinnyLeft = Styled.article`
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  ${media.medium`
    margin-left: 0;
    width: auto;
    max-width: 42.5em;
  `}
`;

LayoutSkinnyLeft.displayName = 'LayoutSkinnyLeft';

export default LayoutSkinny;
